export default "__VITE_ASSET__60fde56a__"